import { useNavigate } from "react-router-dom";

import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// button component that takes you to the previous page you were on
// Note: future improvement could be to take you one "layer" back rather than the page you were on last
function BackButton () {

  const navigate = useNavigate();

    return (
      <IconButton aria-label="back" onClick={() => {navigate(-1)}} sx={{justifyContent: 'flex-start', left: 5}}>
        <ArrowBackIcon sx={{scale: "200%"}}/>
      </IconButton>
    );
};

export default BackButton;